import  React,{useEffect} from 'react';
import Box from '@mui/material/Box';

import CssBaseline from '@mui/material/CssBaseline';

import {ListItemText,Grid} from '@mui/material';
import { Outlet } from 'react-router-dom';
import Header from "./Header"

const drawerWidth = 240;

export default function ClippedDrawer() {


  useEffect(() => {
    document.body.style.backgroundColor = "#fff";

  });

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
 <Header/>      <div className="wrapper d-flex flex-column min-vh-100 ">
      <Box component="main" sx={{flexGrow: 1 ,backgroundColor:"#2264ae",padding:"20px",marginTop:"70px",marginLeft:"20px",marginRight:"20px",borderTopRightRadius:"5px",borderTopLeftRadius:"5px"}}>
             
             <Grid container spacing={2} >
          
             <Outlet />
     </Grid>
     </Box>
     </div>
    </Box>
  );
}